export const siteSettings = {
  name: "Smart Finex Exchange",
  link: "https://smartfinex.net",
  email: "support@smartfinex.net",
  appLink: "https://app.smartfinex.net",
};
